import React from "react";
import { Link } from "react-router-dom";

export default function Confidentialite() {
  return (
    <div className="cs-cream py-16 min-h-[80vh]" data-testid="page-confidentialite">
      <div className="max-w-3xl mx-auto px-6 lg:px-12">
        <div className="cs-eyebrow text-neutral-500">RGPD · Protection des données</div>
        <h1 className="cs-h1 mt-3 text-4xl lg:text-5xl">Politique de confidentialité</h1>
        <p className="mt-2 text-[12px] font-mono text-neutral-500">Dernière mise à jour : février 2026.</p>

        <section className="mt-10 space-y-4 text-[15px] leading-relaxed text-neutral-800">
          <h2 className="cs-h3 text-2xl">Responsable de traitement</h2>
          <p>
            Charbonier Studio — 702 Chemin d'en Vindé, 32130 Labastide-Savès (France),
            SIRET 94745095300015, contact : <a href="mailto:contact@charbonierstudio.fr" className="cs-link-underline">contact@charbonierstudio.fr</a>.
          </p>
        </section>

        <section className="mt-8 space-y-4 text-[15px] leading-relaxed text-neutral-800">
          <h2 className="cs-h3 text-2xl">Données collectées</h2>
          <ul className="list-disc pl-5 space-y-1">
            <li><strong>Compte client</strong> : nom, prénom, adresse email, mot de passe (haché).</li>
            <li><strong>Facturation</strong> : adresse postale, numéro de SIRET / TVA si applicable.</li>
            <li><strong>Commande</strong> : contenu de vos configurateurs (support, dimensions, consignes) et fichiers joints.</li>
            <li><strong>Correspondance</strong> : messages échangés avec le studio dans l'espace client ou par email.</li>
            <li><strong>Paiement</strong> : Stripe conserve les données bancaires. Charbonier Studio n'accède qu'aux références et statuts de paiement.</li>
          </ul>
        </section>

        <section className="mt-8 space-y-4 text-[15px] leading-relaxed text-neutral-800">
          <h2 className="cs-h3 text-2xl">Finalités et bases légales</h2>
          <ul className="list-disc pl-5 space-y-1">
            <li>Exécution du contrat : gestion des commandes, factures, messages, livraison des fichiers.</li>
            <li>Obligation légale : conservation des factures et pièces comptables pendant 10 ans (article L123-22 du Code de commerce).</li>
            <li>Intérêt légitime : sécurité du service (journal des connexions, protection anti-fraude).</li>
          </ul>
          <p>Aucune donnée n'est utilisée à des fins de prospection commerciale.</p>
        </section>

        <section className="mt-8 space-y-4 text-[15px] leading-relaxed text-neutral-800">
          <h2 className="cs-h3 text-2xl">Destinataires</h2>
          <p>
            Vos données sont accessibles uniquement à Charbonier Studio et à ses sous-traitants techniques
            (hébergement, envoi d'emails transactionnels, paiement en ligne). Aucun transfert commercial vers
            un tiers.
          </p>
          <ul className="list-disc pl-5 space-y-1">
            <li><strong>Hébergement</strong> : Emergent (emergent.sh).</li>
            <li><strong>Paiement</strong> : Stripe Payments Europe, Ltd (Irlande).</li>
            <li><strong>Emails</strong> : serveur SMTP de Charbonier Studio (Hostinger).</li>
          </ul>
        </section>

        <section className="mt-8 space-y-4 text-[15px] leading-relaxed text-neutral-800">
          <h2 className="cs-h3 text-2xl">Durée de conservation</h2>
          <ul className="list-disc pl-5 space-y-1">
            <li>Compte client actif : durée de la relation contractuelle + 3 ans après la dernière activité.</li>
            <li>Factures : 10 ans après l'année d'émission.</li>
            <li>Fichiers de projet : durée de la commande + 12 mois, sauf demande de suppression.</li>
          </ul>
        </section>

        <section className="mt-8 space-y-4 text-[15px] leading-relaxed text-neutral-800">
          <h2 className="cs-h3 text-2xl">Vos droits</h2>
          <p>
            Conformément au RGPD et à la loi Informatique et Libertés, vous disposez d'un droit d'accès, de
            rectification, d'effacement, de limitation, de portabilité et d'opposition sur vos données. Pour
            l'exercer, écrivez à <a href="mailto:contact@charbonierstudio.fr" className="cs-link-underline">contact@charbonierstudio.fr</a>.
            Vous pouvez également introduire une réclamation auprès de la CNIL (<a href="https://www.cnil.fr" target="_blank" rel="noreferrer" className="cs-link-underline">cnil.fr</a>).
          </p>
        </section>

        <section className="mt-8 space-y-4 text-[15px] leading-relaxed text-neutral-800">
          <h2 className="cs-h3 text-2xl">Cookies</h2>
          <p>
            Le site n'utilise que les cookies strictement nécessaires à son fonctionnement (session
            d'authentification). Aucun cookie de mesure d'audience, de publicité ou d'analytics tiers n'est déposé.
          </p>
        </section>

        <p className="mt-10 text-[13px] text-neutral-600">
          Pour toute question, consultez les <Link to="/mentions-legales" className="cs-link-underline">mentions légales</Link>
          ou contactez-nous directement.
        </p>
      </div>
    </div>
  );
}
